<template>
  <div>

    <Top v-if="is_pc" />
    <div class="maindiv pproject-wrap bg-gray" :class="!is_pc ? 'mobile-wrap' : ''">
      <Banner v-if="is_pc" />
      <router-link  v-if="!is_pc"  to="/cedu/index" class="dblock tcenter">
        <img src="../../../assets/images/index_01_04.png" style="max-width: 80%;" />
      </router-link>
      <div class="mt25 mt180 bgw htmldiv">
        <banner-title />
        <div class="ncont detail" v-if="flow==0">
          <div class="sign-row center-row">
            <a class="sub-button" href="javascript:;" @click="flow=1">自考报名</a>
            <a class="sub-button" href="javascript:;" @click="flow=2">已报查询</a>
          </div>
        </div>

        <div v-else-if="flow==1" class="ncont detail mobile-detail">
          <div class="sign-row">
            <div class="label">
              <label>年级</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.grade" readonly/>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>姓名</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.name" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>身份证号</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.cid"/>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>性别</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.gender">
                  <option v-for="(item,index) in gender_list" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>政治面貌</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.political">
                  <option v-for="(item,index) in listData.politic" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>手机号码</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.phone" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>学校短号</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.cornet" />
                <span class="content-msg"></span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>QQ号</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.qq" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>本科专业</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.undergraduate_major">
                  <option v-for="(item,index) in undergraduate_major" :value="index">{{item}}</option>
                </select>
<!--                <input class="content-select" v-model="info.undergraduate_major"/>-->
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row" v-if="info.undergraduate_class">
            <div class="label">
              <label>现班级名称</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.undergraduate_class"/>
                <span class="content-msg"></span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>现专科班级</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" type="text" v-model="info.specialized_class"/>
<!--                <el-input-number v-model="info.specialized_class" :min="1" label="班级" style="border: none;width: 345px"></el-input-number>-->
                <span class="content-msg">（<span style='color: red;'>*</span>必填项,提示：中文+数字，如“电商2131”）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>专科专业</label>
            </div>
            <div class="content">
              <div class="content-item">
                <!-- <el-select v-model="info.specialized_major" filterable  placeholder="请选择" class="content-select" style="border: none;">
                  <el-option
                    v-for="(item,index) in listData.class"
                    :key="index"
                    :label="item"
                    :value="index">
                  </el-option>
                </el-select> -->

               <input class="content-select" v-model="info.specialized_major"/>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label" style="vertical-align: top;">
              <label>备注</label>
            </div>
            <div class="content">
              <div class="content-item">
                <textarea class="content-select" v-model="info.remark" style="height: 100px;"></textarea>
                <span class="content-msg"></span>
              </div>
            </div>
          </div>

          <div class="hr-div"></div>

          <div class="sign-row center-row">
            <a class="sub-button" href="javascript:;" @click="submitSign(1)">立即报名</a>
            <a class="sub-button" href="javascript:;" @click="submitSign(2)">保存草稿</a>
          </div>

        </div>

        <div class="ncont detail" v-if="flow==2">
          <div class="sign-row">
            <div class="label">
              <label>请输入手机号</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="search_code"/>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="hr-div"></div>
          <div v-for="(item,index) in searchData" @click="selectSearch(index)" style="margin-left: 35px;margin-bottom: 10px;cursor:pointer">
            {{item.cid}}
            <span v-if="item.save==1" style="color: green;">(已报名)</span>
            <span v-else style="color: red;">(草稿)</span>
          </div>
          <div class="sign-row center-row">
            <a class="sub-button" href="javascript:;" @click="searchSign">立即查询</a>
            <a class="sub-button" href="javascript:;" @click="flow=0">返回</a>
          </div>

        </div>

        <div class="ncont detail" v-if="flow==3">
          <div class="sign-row center-row">
<!--            <img src="../../../assets/images/success.jpg" />-->
            <span style="font-size: 30px;">报名成功!</span>
          </div>

          <div class="hr-div"></div>

          <div class="sign-row center-row">
            <router-link class="sub-button" to="/">返回首页</router-link>
          </div>

        </div>
      </div>
      <div data-v-fd68d6dc="" class="ht30"></div>
    </div>
    <Bottom v-if="is_pc"  />
  </div>
</template>

<script>
import Top from "../top";
import Banner from "../banner";
import Bottom from "../bottom";
import BannerTitle from "./signTitle";

export default {
  name: "detail",
  data () {
    return {
      'id':0,
      'search_code':'',
      'flow':0,
      'pro_name':'',
      'gender_list':{1:'男',2:'女'},
      'undergraduate_major':{'财务管理':'财务管理','工商管理':'工商管理','视觉传达设计':'视觉传达设计', '汽车服务工程': '汽车服务工程'},
      'info':{
        'name':'',
        'cid':'',
        'political':'',
        'phone':'',
        'cornet':'',
        'qq':'',
        'undergraduate_major':'',
        'undergraduate_class':'',
        'specialized_major':'',
        'specialized_class':'',
        'remark':'',
        'save':0,
        'gender':'',
      },
      'fileEducation':'',
      'fileCid':'',
      'fileQualifications':'',
      'listData':[],
      'searchData':[],
      is_pc: true
    }
  },
  components:{
    Top,
    Banner,
    Bottom,
    BannerTitle,
  },
  methods:{
    selectSearch:function(index){
      this.info = this.searchData[index];
      this.flow = 1;
    },
    isCard:function (str) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(str);
    },
    getData:function(){
      this.$request.get('newborn-enroll/option',{},response => {
        if(response.status == 200 && response.data.code == 200){
          this.listData = response.data.data;
        }
      },error => {
        console.log(error);
      })
    },

    submitSign:function(save){
      this.info.save = save;
      let param = new FormData();
      // for(let key in this.info){
      //   param.append(key,this.info[key]);
      // }
      this.$request.post('newborn-enroll/enroll',this.info,response => {
        if(response.status == 200 && response.data.code == 200){
          //报名成功
          if(save == 2){
            this.flow = 0
          }else{
            this.flow = 3;
          }
        }else{
          alert(response.data.message);
        }
      },error => {
        console.log(error);
      })
    },
    searchSign:function () {
      var param = {
        phone:this.search_code,
      };
      this.$request.get('newborn-enroll/get-detail',param,response => {
        if(response.status == 200 && response.data.code == 200){
          this.searchData = response.data.data;
          // this.flow = 1;
        }else{
          alert(response.data.message);
        }
      },error => {
        console.log(error);
      })
    }
  },
  created() {
    var date = new Date();
    this.info.grade = date.getFullYear();
    this.getData();
    this.is_pc = this.$request.isPc() ? true : false
    if(!this.is_pc)
      document.body.style.minWidth = 'auto'
    
  },
  mounted() {

  },
  watch:{
    'info.cid':{
      deep:true,
      handler:function (n,o) {
        if(this.$request.isCard(n)){
          this.info.gender = this.$request.getSex(n);
        }
      }
    },
  },
}
</script>

<style scoped>
  .pproject-wrap .detail{padding: 50px 55px 40px;}
  .hr-div{width: 100%;height: 1px;border-top: 1px solid rgb(233,233,233);margin: 30px 0}
  .sign-row{min-height: 40px;line-height: 26px;margin-top: 14px;}
  .sign-row26{min-height: 26px;}
  .sign-row .label{width: 130px;display: inline-block;line-height: 35px;text-align: right;font-size: 16px;color: rgb(51,51,51);}
  .sign-row .content{width: 990px;display: inline-block;margin-left: 40px;}
  .sign-row .content-select{width: 345px;height: 34px;line-height: 34px;border: 1px solid rgb(212,218,221);background: rgb(243,243,243);}
  .sign-row .content-select3{width:120px;margin-right: 15px;}
  .sign-row .content-select2{width:61px;margin-right: 10px;}
  .sign-row .content-select1{width:50px;margin-right: 5px;}
  .sign-row .content-item{vertical-align: middle;color: rgb(119,119,119);}
  .sign-row .content-item .insert-label{width:26px;}
  .sign-row .content-item input[type=checkbox]{vertical-align: top;width:18px;height:18px;margin-right: 12px;margin-top: 5px;}
  .sign-row .content-item label{vertical-align: top;display: inline-block;width:900px;}
  .sign-row .content-item input[type=file]{display: none;}
  .sign-row .content-item .changeButton{vertical-align: middle;display: inline-block;width: 48px;height: 34px;line-height: 34px;text-align: center;border: 1px solid #d4dadd;background: #f3f3f3;}
  .sign-row .sub-button{display: inline-block;margin: 0 auto;width: 180px;height: 46px;line-height: 46px;text-align: center;background: #3a8c39;color: #fff;border-radius: 5px;}
  .center-row{text-align: center;}

  .mobile-wrap .mt180{
    margin-top: 0;
  }
  .mobile-wrap .htmldiv{
    max-width: 100%;
  }
    
  /* @media (max-width: 992px) { */
   
    .mobile-wrap .stt{
      padding: 20px 10px 0;
    }
    .mobile-wrap .mobile-detail{
      padding: 20px 20px 50px;
    }
    .mobile-wrap .mobile-detail .label{
      text-align: left;
    }
    .mobile-wrap .sign-row .content{
      margin-left: 0;
    }
    .mobile-wrap .mobile-detail .label,
    .mobile-wrap .sign-row .content,
    .mobile-wrap .sign-row .content-msg{
      display: block;
      width: 100%;
    }
    .mobile-wrap .mobile-detail .sign-row .content{
      width: 100%;
    }
    .mobile-wrap .sign-row .content-select{
      padding: 0 10px;
      width: 100%;
    }
    .mobile-wrap .sign-row .sub-button{
      max-width: 40%;
    }
  /* } */
 
</style>



// WEBPACK FOOTER //
// src/components/cedu/index/sign.vue